/**
 * @fileoverview HTTP connection
 */
'use strict';
// Library Import
import axiosBase from 'axios';
// Config Import
import AppConfig from '../AppConfig';
// Util Import
import * as LogUtil from '../util/LogUtil';

/**
 * HTTP
 *
 * @class HTTP
 */
class HTTP {
  constructor() {
    this.axios = null;
  }

  /**
   * インスタンス生成
   *
   * @param {String} baseUrl ベースURL
   * @param {Object} headers HTTPヘッダー
   * @param {Integer} timeout タイムアウト
   * @memberof HTTP
   */
  createInstance(baseUrl, headers, timeout) {
    this.axios = axiosBase.create({
      baseURL: baseUrl,
      headers: headers,
      timeout: timeout
    });
  }

  /**
   * REST-API の POST メソッドを実行する
   *
   * @param {String} url REST-API のURL
   * @param {Object} data axios のオプションに指定するdata
   * @param {Function} callback 呼び出し元のコールバック処理
   * @memberof HTTP
   */
  post(url, data, callback) {
    if (!this.axios) {
      LogUtil.d('ERROR!! You must call createInstance method.');
      return;
    }

    this.axios
      .post(AppConfig.versionInformation.api + url, data)
      .then(function(res) {
        // 正常時
        LogUtil.d('api:' + url);
        callback(null, res);
      })
      .catch(function(error) {
        // 異常時
        LogUtil.d('HTTP POST ERROR!! happend by Backend.');
        callback(error, null);
      });
  }

  /**
   * REST-API の PUT メソッドを実行する
   *
   * @param {String} url REST-API のURL
   * @param {Object} data axios のオプションに指定するdata
   * @param {Object} config axiosのconfig設定
   * @param {Function} callback 呼び出し元のコールバック処理
   * @returns
   * @memberof HTTP
   */
  put(url, data, config, callback) {
    if (!axiosBase) {
      LogUtil.d('ERROR!! You must import axiosBase');
      return;
    }

    axiosBase
      .put(url, data, config)
      .then(function(res) {
        // 正常時
        LogUtil.d('api:' + url);
        callback(null, res);
      })
      .catch(function(error) {
        // 異常時
        LogUtil.d('HTTP PUT ERROR!! happend by Backend.');
        callback(error, null);
      });
  }

  /**
   * REST-API の GET メソッドを実行する
   *
   * @param {String} url REST-API のURL
   * @param {Object} data axios のオプションに指定するdata
   * @param {Function} callback 呼び出し元のコールバック処理
   * @memberof HTTP
   */
  get(url, data, callback) {
    if (!this.axios) {
      LogUtil.d('ERROR!! You must call createInstance method.');
      return;
    }

    this.axios
      .get(AppConfig.versionInformation.api + url, { params: data })
      .then(function(res) {
        // 正常時
        LogUtil.d('api:' + url);
        callback(null, res);
      })
      .catch(function(error) {
        // 異常時
        LogUtil.d('HTTP GET ERROR!! happend by Backend.');
        callback(error, null);
      });
  }
}
export default new HTTP();



// WEBPACK FOOTER //
// ./src/js/connection/HTTP.jsx